import React, { useMemo, useEffect } from "react";
import { Line } from "@react-three/drei";
import * as THREE from "three";
import GridResults3D from "./GridResults3D";

const Grid3D = ({ grid, gridScale = 1, areaResults, state }) => {
  const [gridResults, setGridResults] = React.useState([]);

  const borderPoints = useMemo(() => {
    const { origin } = grid;
    const width = origin.x.length * gridScale;
    const height = origin.y.length * gridScale;

    const x = origin.x.start * gridScale;
    const y = origin.y.start * gridScale * -1;
    const z = 0.1;

    const scaleX = grid.scaleX ?? 1;
    const scaleY = grid.scaleY ?? 1;
    const rotationDeg = grid.angle ?? 0;
    const rotationRad = -(rotationDeg * Math.PI) / 180;

    const anchor = new THREE.Vector2(x, y);

    const corners = [
      new THREE.Vector2(x, y),
      new THREE.Vector2(x + width, y),
      new THREE.Vector2(x + width, y - height),
      new THREE.Vector2(x, y - height),
    ];

    const transformed = corners.map((p) => {
      const translated = new THREE.Vector2().subVectors(p, anchor);
      translated.x *= scaleX;
      translated.y *= scaleY;

      const rotated = new THREE.Vector2(
        translated.x * Math.cos(rotationRad) - translated.y * Math.sin(rotationRad),
        translated.x * Math.sin(rotationRad) + translated.y * Math.cos(rotationRad)
      );

      return rotated.add(anchor);
    });

    transformed.push(transformed[0]);

    return transformed.map((p) => [p.x, p.y, z]);
  }, [grid, gridScale]);

  useEffect(() => {
    if (!areaResults) return;
    for (var i = 0; i < areaResults.length; i++) {
      var item = areaResults[i];
      if (item.calcResults?.outdoorResults[0]?.gridId == grid.id) {
        setGridResults(item.calcResults?.outdoorResults[0]?.contourResults);
        break;
      }
    }
  }, [areaResults])

  return (
    <>
      <Line
        points={borderPoints}
        color={grid.color || "gray"}
        lineWidth={3}
        opacity={0.5}
      />
      {gridResults?.length > 0 && (
        <GridResults3D
          grid={grid}
          results={gridResults}
          gridScale={gridScale}
          showValues={state.showValues}
        />
      )}
    </>
  );
};

export default Grid3D;
